/* tslint:disable max-line-length */

export enum RoleKeys {
  ADMIN = 'ADMIN',
  MANAGER = 'MANAGER',
  ACCOUNTING = 'ACCOUNTING',
  OWNER = 'OWNER',
  STAFF = 'STAFF',
  GUEST = 'GUEST',
  READ_ONLY = 'READ-ONLY',
}

export const readOnlyPermission = 'readOnly'

export const roles = {
  [RoleKeys.ADMIN]: [
    'canSeeQuickStartGuide',
    'canSeeDocuments',
    'admin',
    'canSeeAppStore',
    'canMigrateToSympl',
    'canSeeOwnerCenter',
    'canSeeYearlyPlanAnnouncement',
    'canSeeAirbnbVersion1Announcement',
    'canSeeAirbnbICalAnnouncement',
    'canSeePricingAnnouncement',
    'canChangePassword',
    'canSeeAutomations',
    'canSeeStealth',
    'canSeeChangelog',
    'canUseSearch',
    'canSeeNotifications',
    'canSeeAIChat',
    'canDeleteAccount',
    'canSeeAccount',
    'canSeeReports',
    'canSeeExpenses',
    'canSeeCalendar',
    'canSeeMultiCalendar',
    'canSeeStandardCalendar',
    'canSeePlanningCalendar',
    'canSeeAgenda',
    'canSeeHold',
    'canSeeICalURL',
    'canSeeInventories',
    'canSeeIncidents',
    'canSeeTasks',
    'canSeeVendors',
    'canSeeSettings',
    'canSeeInquiries',
    'canSeeRentals',
    'canSeeInvoices',
    'canSeeCharges',
    'canSeeSmartDevices',
    'canSeeDiscounts',
    'canSeeBilling',
    'canSeeGuests',
    'canSeeRates',
    'canSeeDataFeeds',
    'canSeeChannels',
    'canSeeWidgets',
    'canSeeWebsites',
    'canEditUser',
    'canSeeIntegrations',
    'canSeeMessagingSettings',
    'canSeePayments',
    'canSeeSharing',
    'canSeeTemplates',
    'canSeeAddons',
    'canAddInquiry',
    'canEditInquiry',
    'canAddHold',
    'canEditHold',
    'canEditRental',
    'canEditGuest',
    'canEditNotes',
    'canAddRates',
    'canSeeContracts',
    'canSeeAllRentals',
    'canSeeCalendarActions',
    'canSeeDashboard',
    'canAddTasks',
    'canEditTasks',
    'canDeleteTasks',
    'canApproveTasks',
    'canAddIncidents',
    'canEditIncidents',
    'canDeleteIncidents',
    'canAddInventories',
    'canEditInventories',
    'canDeleteInventories',
    'canSeeGuestContacts',
    'canSeeReviews',
    'canSeeAirbnbQuality',
    'canAISettings',
    'canUseGlobalPush',
    'canUseCostEstimator',
    'canUseGlobalAdd',
    'canSeeExpenseSettings',
    'canSeeAccessCodes',
  ],
  [RoleKeys.MANAGER]: [
    'canSeeQuickStartGuide',
    'canSeeDocuments',
    'manager',
    'canSeeOwnerCenter',
    'canSeeYearlyPlanAnnouncement',
    'canSeeAirbnbVersion1Announcement',
    'canSeeAirbnbICalAnnouncement',
    'canSeePricingAnnouncement',
    'canChangePassword',
    'canSeeAutomations',
    'canSeeStealth',
    'canSeeChangelog',
    'canUseSearch',
    'canSeeNotifications',
    'canSeeAIChat',
    'canSeeAccount',
    'canSeeReports',
    'canSeeExpenses',
    'canSeeCalendar',
    'canSeeMultiCalendar',
    'canSeeStandardCalendar',
    'canSeePlanningCalendar',
    'canSeeAgenda',
    'canSeeICalURL',
    'canSeeHold',
    'canSeeInventories',
    'canSeeIncidents',
    'canSeeTasks',
    'canSeeVendors',
    'canSeeSettings',
    'canSeeInquiries',
    'canSeeRentals',
    'canSeeInvoices',
    'canSeeCharges',
    'canSeeSmartDevices',
    'canSeeDiscounts',
    'canSeeGuests',
    'canSeeRates',
    'canSeeDataFeeds',
    'canSeeChannels',
    'canSeeWidgets',
    'canSeeWebsites',
    'canSeeIntegrations',
    'canSeeMessagingSettings',
    'canSeePayments',
    'canSeeSharing',
    'canSeeTemplates',
    'canSeeAddons',
    'canAddInquiry',
    'canEditInquiry',
    'canAddHold',
    'canEditHold',
    'canEditRental',
    'canEditGuest',
    'canEditNotes',
    'canAddRates',
    'canSeeContracts',
    'canSeeAllRentals',
    'canSeeCalendarActions',
    'canSeeDashboard',
    'canAddTasks',
    'canEditTasks',
    'canDeleteTasks',
    'canApproveTasks',
    'canAddIncidents',
    'canEditIncidents',
    'canDeleteIncidents',
    'canAddInventories',
    'canEditInventories',
    'canDeleteInventories',
    'canSeeGuestContacts',
    'canSeeReviews',
    'canSeeAirbnbQuality',
    'canAISettings',
    'canUseGlobalPush',
    'canUseCostEstimator',
    'canUseGlobalAdd',
    'canSeeAccessCodes',
  ],
  [RoleKeys.READ_ONLY]: [
    readOnlyPermission,
    'canSeeOwnerCenter',
    'canSeeYearlyPlanAnnouncement',
    'canSeeAirbnbVersion1Announcement',
    'canSeeAirbnbICalAnnouncement',
    'canSeePricingAnnouncement',
    'canChangePassword',
    'canSeeAutomations',
    'canSeeStealth',
    'canSeeChangelog',
    'canUseSearch',
    'canSeeNotifications',
    'canSeeAccount',
    'canSeeReports',
    'canSeeExpenses',
    'canSeeCalendar',
    'canSeeMultiCalendar',
    'canSeeStandardCalendar',
    'canSeePlanningCalendar',
    'canSeeAgenda',
    'canSeeICalURL',
    'canSeeHold',
    'canSeeInventories',
    'canSeeIncidents',
    'canSeeTasks',
    'canSeeSettings',
    'canSeeInquiries',
    'canSeeRentals',
    'canSeeInvoices',
    'canSeeCharges',
    'canSeeSmartDevices',
    'canSeeDiscounts',
    'canSeeGuests',
    'canSeeRates',
    'canSeeChannels',
    'canSeeWidgets',
    'canSeeWebsites',
    'canSeeIntegrations',
    'canSeeMessagingSettings',
    'canSeePayments',
    'canSeeSharing',
    'canSeeTemplates',
    'canSeeAddons',
    'canSeeContracts',
    'canSeeAllRentals',
    'canSeeDashboard',
    'canSeeGuestContacts',
    'canSeeReviews',
    'canSeeAirbnbQuality',
    //
    // 'canEditInquiry',
    // 'canAddHold',
    // 'canEditHold',
    // 'canEditRental',
    // 'canEditGuest',
    // 'canEditNotes',
    // 'canDeleteTasks',
  ],
  [RoleKeys.ACCOUNTING]: [
    //
    'accounting',
    'canSeeReports',
  ],
  [RoleKeys.OWNER]: [
    //
    'owner',
    'canSeeCalendar',
    'canSeeMultiCalendar',
    'canSeeStandardCalendar',
    'canEditHold',
    'canAddHold',
  ],
  [RoleKeys.STAFF]: [
    'staff',
    'canSeeCalendar',
    'canSeeMultiCalendar',
    'canSeeStandardCalendar',
    'canSeePlanningCalendar',
    'canSeeAgenda',
    'canSeeHold',
    'canSeeTasks',
    'canSeeInventories',
    'canSeeIncidents',
    'canAddTasks',
    'canAddIncidents',
    'canAddInventories',
    'canSeeAllRentals',
    'canSeeGuestContacts',
    'canEditTasks',
    'canEditIncidents',
    'canEditInventories',
    'canEditNotes',
  ],
  [RoleKeys.GUEST]: [],
}
